module.exports = __webpack_public_path__ + "static/GorditaRegular-eb4c6f0bca2182d4883743da4b497942.woff2";